<template>
  <div class="fuzzy-matching-box">
       <!-- 考勤短信设置 -->
     <div class="showBox" v-if="titleValue == '考勤短信设置'">
      <div class="header-Top-Box">
           <!-- <h1 class="anquan-text">考勤短信设置</h1> -->
           <div class="school-seacher">
               <el-row>
                   <el-col :span="12">
                       <el-form-item  label="名称：">
                           <el-input  placeholder='' v-model="from.schoolName"></el-input>
                       </el-form-item>
                    </el-col >
                  
                          <el-button type="primary" class="query-button" @click="entrylogClick">查询</el-button>
           </el-row>
           </div>
       </div>
       <div class="center-table-box"> 
           <el-table
                 stripe
                :border="true"
                class="table-Style"
                ref="multipleTable"
                :header-cell-style="{background:'#EDF6FF',color:'#000',}"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleSelectionChange">
                <el-table-column
                prop="name"
                label="名称"
             >
               </el-table-column>
               <el-table-column
               prop="address"
               label="地址"
             >
               </el-table-column>
               <el-table-column
               label="操作"
               >
               <template #default="scope">
                    <el-button type="text" size="small" class="textButton"  @click="TimeShezhi(scope.row)">考勤短信设置</el-button>
                  </template>
               </el-table-column>
           </el-table>
           <div class="block-fenye" >
           <el-pagination
               :small="small"
               :disabled="disabled"
               :background="background"
               layout="prev, pager, next, jumper"
               :total="total"
               @size-change="handleSizeChange"
               @current-change="handleCurrentChange"
             />
         </div>
       </div>
     </div>
     <NoteAdd v-if="titleValue == '短信设置'" @schoolShowClick="schoolShowClick" :TimeObj="TimeObj"></NoteAdd>
  </div>
</template>
<script>
import {schoolList} from '@/assets/api/renyuan'
import NoteAdd from './NoteAdd/index.vue'

export default {
  name: '',
  components: {
    NoteAdd
  },
  mixins: [],
  props: {
    
  },
  data() {
    return {
      tableData:[
      ],
      pageInfo:{
        page:'1',
        pageSize:'10'
      },
      total:'',
      from:{
        schoolName:''
      },
      titleValue:'考勤短信设置',
      TimeObj:{}
    }
  },
  created(){
    this.DuanxinTimelist()
  },
  watch: {
    
  },
  mounted() {
    
  },
  methods: {
    schoolShowClick(){
      this.titleValue = '考勤短信设置'
    },
    TimeShezhi(item){
      this.TimeObj = item
      this.titleValue = '短信设置'
    },
    //搜索
    entrylogClick(){
      this.DuanxinTimelist()
    },
    // 列表
    DuanxinTimelist(){
      const params =  JSON.parse(localStorage.getItem('user')).id;
      schoolList(params).then((res) => {
        this.tableData = res.data.data
        this.total = res.data.data.length;
        console.log(res);
      }).catch((err) => {
        console.log(err);
      })
    }
  }
};
</script>
<style lang='scss' scoped>
   .fuzzy-matching-box{
       height: 96%;
       .showBox{
        height: 96%;
       }
       .header-Top-Box{
           height: 10%;
           background-color: #fff;
           border-radius: 10px;
           display: flex;
            align-items: center; /*垂直居中*/
          .anquan-text{
           line-height:-20% !important;
           font-size: 18px;
           font-weight: 700;
           margin-left: 20px;

          }
          .school-seacher{
           /deep/{
               .el-row{
                   height: 40px;
                   line-height: 40px !important;
                   text-align: center;
                   margin-left: 30px;
                   
               }
               .el-input--small .el-input__inner{
                   height: 30px;
                   
               }
               .el-input--small .el-input__wrapper{
                  //  border-radius: 15px;
               }
               .el-form-item--small .el-form-item__label {
                   line-height: 30px !important;
                   font-size: 16px;
                   color: black;
               }
               .el-input__inner {
                   width: 150px;
                   margin-right:50px !important;
                   border-radius: 15px;
               }
               .query-button{
                   margin-left: 100px;
                  //  background-color:#1BC896;
                   font-size: 16px;
                   height: 30px
               }

           }
           
          }

       }
       .center-table-box{
           height: 90%;
           margin-top: 20px;
           background-color: #fff;
           // background-color: green;
           border-radius: 10px;
           // overflow: auto;
           padding: 20px;
           .textButton {    
            font-size: 15px;
            font-weight: 700;
          }
           .table-Style{
              //  border-radius: 15px;
           }
           /deep/{
               .el-table th.el-table__cell>.cell{
                   height: 30px;
                   text-align: center;
                   font-size: 15px;
                   font-weight: 700;
               }
               .el-table__header{
                   height: 30px;
                   font-size: 16px;
                   font-weight: 700;
                   border-radius: 15px;

               }
               .el-table--enable-row-transition .el-table__body td.el-table__cell {
                  //  border: none;
                   height: 40px;
                   font-size: 16px;
                   text-align: center;
               }
               .el-button--small {
                font-size: 16px;
                // color: #1BC896;
               }
               }
           .block-fenye{
               margin-top: 20px;
               margin-left: 80%;
           }
       }
   }
</style>